import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VSnackbar, {
    attrs: {
      "bottom": true,
      "right": true,
      "color": _vm.snackbar.color,
      "dark": ""
    },
    model: {
      value: _vm.snackbar.model,
      callback: function ($$v) {
        _vm.$set(_vm.snackbar, "model", $$v);
      },
      expression: "snackbar.model"
    }
  }, [_vm.snackbar.model ? _c('div', {
    staticClass: "snackDesign"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.textColor,
      "size": "20"
    }
  }, [_vm._v("fal fa-bell-plus")]), _c('div', {
    style: `margin-left: 10px; color: ${_vm.textColor}`,
    attrs: {
      "data-cy": "snackMessage"
    }
  }, [_vm._v("\n      " + _vm._s((_vm.snackbar.message || 'MESSAGE_TEXT_IS_UNDEFINED').replace(/_/g, ' ')) + "\n      "), _vm.snackbar.link ? _c('span', [_vm._v("\n         \n        "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.snackbar.link.click
    }
  }, [_c('em', [_vm._v("» " + _vm._s(_vm.snackbar.link.message))])])]) : _vm._e()]), _c(VSpacer), _c(VIcon, {
    attrs: {
      "color": _vm.textColor,
      "size": "16"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("fal fa-times-cirlce")])], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };